import { atom } from 'recoil';

export const emissionsCalculatorEditingSegmentIndexState = atom<number | null>({
  key: 'emissionsCalculatorEditingSegmentIndexState',
  default: null,
});

export const emissionsCalculatorResultsWarningsState = atom<boolean>({
  key: 'emissionsCalculatorResultsWarningsState',
  default: false,
});

// Atom to track when to trigger the emissions calculation
export const emissionsTriggerCalculation = atom<number>({
  key: 'emissionsTriggerCalculation',
  default: 0,
});

// Controls whether segments should be automatically appended when a location
// is added. Useful for loading data directly into the form state
export const emissionsCalculatorAutoAppendEnabledState = atom<boolean>({
  key: 'emissionsCalculatorAutoAppendEnabledState',
  default: true,
});
